// Starter templates for fast survey deployment. Each template's `questions` use
// the same JSON shape the import endpoint accepts; `survey` holds settings applied
// via adminUpdate right after the blank survey is created.
import { LIKERT_PRESETS } from './questionTypes';

const agreement = () => ({ points: LIKERT_PRESETS.agreement });
const stars = () => ({ scale_min: 1, scale_max: 5, icon: 'star' });

export const SURVEY_TEMPLATES = [
  {
    key: 'blank',
    label: 'Blank survey',
    description: 'Start from scratch.',
    survey: {},
    questions: [],
  },
  {
    key: 'enps',
    label: 'Employee NPS (eNPS)',
    description: 'How likely are staff to recommend KSP as a place to work?',
    survey: { description: 'A quick pulse on how you feel about working at KSP.', is_anonymous: true },
    questions: [
      { question_type: 'nps', question_text: 'How likely are you to recommend KSP as a place to work?', is_required: true, config: {} },
      { question_type: 'long_text', question_text: 'What is the main reason for your score?', is_required: false, config: { placeholder: 'Optional', max_length: 1000 } },
    ],
  },
  {
    key: 'post_training',
    label: 'Post-training feedback',
    description: 'Collect feedback after a training course.',
    survey: { description: 'Help us improve this training.' },
    questions: [
      { question_type: 'likert', question_text: 'The training was clear and easy to follow.', is_required: true, config: agreement() },
      { question_type: 'likert', question_text: 'I feel confident applying what I learned.', is_required: true, config: agreement() },
      { question_type: 'rating', question_text: 'Overall, how would you rate this training?', is_required: true, config: stars() },
      { question_type: 'long_text', question_text: 'Any suggestions to improve it?', is_required: false, config: { max_length: 1000 } },
    ],
  },
  {
    key: 'safety',
    label: 'Safety check-in',
    description: 'A quick safety pulse for the floor.',
    survey: { description: 'Your safety matters. This takes under a minute.', is_anonymous: true },
    questions: [
      { question_type: 'yes_no', question_text: 'Do you have the PPE you need to do your job safely?', is_required: true, options: [{ option_text: 'Yes', option_value: '1' }, { option_text: 'No', option_value: '0' }] },
      { question_type: 'likert', question_text: 'I feel comfortable reporting safety concerns.', is_required: true, config: agreement() },
      { question_type: 'long_text', question_text: 'Describe any safety hazard you have noticed.', is_required: false, config: { max_length: 1000 } },
    ],
  },
  {
    key: 'onboarding',
    label: 'Onboarding experience',
    description: 'Gather feedback from recent hires.',
    survey: { description: 'Tell us about your first weeks at KSP.' },
    questions: [
      { question_type: 'rating', question_text: 'How would you rate your onboarding experience?', is_required: true, config: stars() },
      { question_type: 'likert', question_text: 'I had the tools and access I needed on day one.', is_required: true, config: agreement() },
      { question_type: 'single_choice', question_text: 'Which area needs the most improvement?', is_required: false, options: [{ option_text: 'Training' }, { option_text: 'Equipment & access' }, { option_text: 'Communication' }, { option_text: 'Scheduling' }, { option_text: 'Other' }] },
      { question_type: 'long_text', question_text: 'Anything else you would like us to know?', is_required: false, config: { max_length: 1000 } },
    ],
  },
];

export default SURVEY_TEMPLATES;
